import Pagination from './Pagination.vue';
export { Pagination };



// WEBPACK FOOTER //
// ./src/uikit/components/lib/tui-pagination-vue/index.js